"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGetWishlistSuggestions = exports.ZPrizeDisplayGroup = exports.ZDashboardPrize = exports.ZPrizeCore = exports.ZProductInsert = exports.ZProductSelect = exports.ZAutoFulfilmentDetail = exports.ZPrizeInsert = exports.ZPrizeSelect = exports.PrizeStatusEnum = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.PrizeStatusEnum = dbEnums_1.PrizeStatus;
exports.ZPrizeSelect = zodSchemas_generated_1.zodSelectPrize.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPrize.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    imageLocations: dbJsonModels_1.ZPrizeImageLocations,
    seoImageAltText: zod_1.z.object({
        main: zod_1.z.string(),
        secondary1: zod_1.z.string().optional(),
        secondary2: zod_1.z.string().optional(),
    }),
    internalInfo: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    additionalQuestionsForPlayer: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
}));
exports.ZPrizeInsert = zodSchemas_generated_1.zodInsertPrize.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertPrize.shape, {
    imageLocations: dbJsonModels_1.ZPrizeImageLocations,
    seoImageAltText: zod_1.z.object({
        main: zod_1.z.string(),
        secondary1: zod_1.z.string().optional(),
        secondary2: zod_1.z.string().optional(),
    }),
    internalInfo: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    additionalQuestionsForPlayer: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
}));
exports.ZAutoFulfilmentDetail = zod_1.z.object({
    GIFTCLOUD_REWARD: zod_1.z
        .object({
        code: zod_1.z.string(),
    })
        .optional(),
});
exports.ZProductSelect = zodSchemas_generated_1.zodSelectProductCatalog.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectProductCatalog.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    autoFulfilmentDetail: exports.ZAutoFulfilmentDetail,
}));
exports.ZProductInsert = zodSchemas_generated_1.zodInsertProductCatalog.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertProductCatalog.shape, {
    price: zod_1.z.coerce.number().optional(),
    autoFulfilmentDetail: exports.ZAutoFulfilmentDetail.optional(),
}));
exports.ZPrizeCore = exports.ZPrizeSelect.pick({
    id: true,
    slug: true,
    title: true,
    subheading: true,
    isFromPlayersSuggestion: true,
}).extend({
    heroImageLocation: zod_1.z.string(),
});
exports.ZDashboardPrize = zod_1.z.object({
    prizeInstanceId: zod_1.z.number(),
    title: zod_1.z.string(),
    subheading: zod_1.z.string(),
    slug: zod_1.z.string(),
    heroImageLocation: zod_1.z.string(),
});
exports.ZPrizeDisplayGroup = zod_1.z.nativeEnum(dbEnums_1.PrizeDisplayGroup);
exports.ZGetWishlistSuggestions = exports.ZPrizeCore.array();
//# sourceMappingURL=models.js.map